import { render, staticRenderFns } from "./ThumbnailContextMenu.vue?vue&type=template&id=ca81bb5c&scoped=true&"
import script from "./ThumbnailContextMenu.vue?vue&type=script&lang=js&"
export * from "./ThumbnailContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca81bb5c",
  null
  
)

export default component.exports